import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export interface ContentProps {
  sideBarCollapsed: boolean
}

export interface MainContentProps {
  headerCollapsed: boolean
}

export const Container = styled(Box)`
  width: 100%;
  display: flex;
`

export const Content = styled(Box)<ContentProps>`
  ${({ theme, sideBarCollapsed }) => css`
    width: ${`calc(100% - ${sideBarCollapsed ? '290px' : '126px'} )`};
    display: flex;
    flex-direction: column;
    transition: width 0.3s;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
    }
  `}
`

export const MainContent = styled(Box)<MainContentProps>`
  ${({ theme, headerCollapsed }) => css`
    overflow: auto;
    height: calc(100vh - 104px);

    @media (max-width: ${theme.screenSizes.laptop}) {
      height: ${`calc(100vh - ${headerCollapsed ? '312px' : '120px'} )`};
    }
  `}
`

export const Footer = styled(Box)`
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`

export const FooterMessage = styled.span`
  ${({ theme }) => css`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.28px;
    text-align: center;
    color: ${theme.colors.primary};
  `}
`

export const BrandText = styled(FooterMessage)`
  font-weight: 700;
  margin-left: 4px;
`
